import { createApi } from "@reduxjs/toolkit/query/react";
import { RIDER_REQUEST } from "../../configs";
import { RiderRequest } from "../../types";
import { createBaseQuery } from "../helpers/baseQueryHelper";

const riderRequestApi = createApi({
  reducerPath: RIDER_REQUEST.reducerPath,
  baseQuery: createBaseQuery(RIDER_REQUEST.baseUrl),
  tagTypes: RIDER_REQUEST.tagTypes,
  endpoints(builder) {
    return {
      createRiderRequest: builder.mutation<
        RiderRequest,
        Omit<RiderRequest, "_id">
      >({
        query: (body) => ({
          url: "/",
          method: "POST",
          body,
        }),
        invalidatesTags: [{ type: RIDER_REQUEST.tagTypes[0], id: "LIST" }],
      }),
    };
  },
});

// Export hooks
export const { useCreateRiderRequestMutation } = riderRequestApi;

export { riderRequestApi };
